export default __webpack_public_path__ + "static/media/8.97b72295.jpg";